<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalCount }}</span>
          <span class="stats-card-label">Total Checklists</span>
          <span class="stats-card-sublabel">All templates</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list-check"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ activeCount }}</span>
          <span class="stats-card-label">Active</span>
          <span class="stats-card-sublabel">Visible to PMs</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ inactiveCount }}</span>
          <span class="stats-card-label">Inactive</span>
          <span class="stats-card-sublabel">Hidden from PMs</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-minus-circle"></i></div>
      </div>
      <div class="stats-card stats-card--info">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalItemCount }}</span>
          <span class="stats-card-label">Total Items</span>
          <span class="stats-card-sublabel">Across all checklists</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-question-circle"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4"
      [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="applyFilters()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <!-- Templates table -->
    <p-table
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredTemplates"
      [loading]="loading"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [first]="first"
      [rowsPerPageOptions]="[10, 25, 50, 100]"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} checklists"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable no-column-lines"
      dataKey="id"
      [expandedRowKeys]="expandedRows">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem"></th>
          <th pSortableColumn="name">
            Checklist Name <p-sortIcon field="name" />
          </th>
          <th style="width: 80px; text-align: center">Items</th>
          <th style="width: 120px">Status</th>
          <th class="th-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-template>
        <!-- Main template row -->
        <tr [class.row-expanded-parent]="isExpanded(template)"
            [class.row-inactive]="template.isActive === false">
          <!-- Expand toggle -->
          <td class="expand-td">
            <button class="expand-btn" type="button" (click)="toggleRow(template)"
              [pTooltip]="isExpanded(template) ? 'Hide items' : 'View items'"
              tooltipPosition="top">
              <i [class]="isExpanded(template) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
            </button>
          </td>

          <!-- Clickable name -->
          <td class="td-name" (click)="toggleRow(template)" style="cursor:pointer">
            <div class="cl-name-cell">
              <strong>{{ template.name }}</strong>
            </div>
          </td>

          <td style="text-align: center">
            <span class="item-count-badge">{{ template.itemCount }}</span>
          </td>

          <td>
            <span [class]="template.isActive ? 'status-badge status-badge--active' : 'status-badge status-badge--inactive'">
              {{ template.isActive ? 'Active' : 'Inactive' }}
            </span>
          </td>

          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button
                [icon]="template.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [severity]="template.isActive ? 'success' : 'secondary'"
                [text]="true"
                (onClick)="toggleStatus(template)"
                size="small"
                [pTooltip]="template.isActive ? 'Active — click to deactivate' : 'Inactive — click to activate'"
                tooltipPosition="top" />
              <p-button
                icon="pi pi-pencil"
                (onClick)="openEditDialog(template)"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="Edit checklist name"
                tooltipPosition="top" />
              <p-button
                icon="pi pi-trash"
                (onClick)="deleteTemplate(template)"
                [text]="true"
                severity="danger"
                size="small"
                pTooltip="Delete checklist"
                tooltipPosition="top" />
            </div>
          </td>
        </tr>

        <!-- Inline expanded items section -->
        <tr *ngIf="isExpanded(template)" class="expansion-tr">
          <td colspan="5" class="expansion-td">
            <div class="items-panel">

              <!-- Items list -->
              <div class="items-list" *ngIf="template.items && template.items.length > 0">
                <div
                  *ngFor="let item of template.items; let i = index"
                  class="item-row"
                  [class.item-row--inactive]="!item.isActive"
                  [class.item-row--editing]="editingItemId === item.id">

                  <span class="item-num">{{ item.displayOrder }}</span>

                  <!-- View mode -->
                  <ng-container *ngIf="editingItemId !== item.id">
                    <span class="item-question-text">{{ item.question }}</span>
                    <div class="item-actions">
                      <p-button
                        icon="pi pi-pencil"
                        [text]="true"
                        severity="info"
                        size="small"
                        pTooltip="Edit"
                        tooltipPosition="top"
                        (onClick)="startEditItem(item)" />
                      <p-button
                        [icon]="item.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                        [text]="true"
                        [severity]="item.isActive ? 'success' : 'secondary'"
                        size="small"
                        [pTooltip]="item.isActive ? 'Active — click to deactivate' : 'Inactive — click to activate'"
                        tooltipPosition="top"
                        (onClick)="toggleItemActive(template, item)" />
                      <p-button
                        icon="pi pi-trash"
                        [text]="true"
                        severity="danger"
                        size="small"
                        pTooltip="Delete"
                        tooltipPosition="top"
                        (onClick)="deleteItemInline(template, item)" />
                    </div>
                  </ng-container>

                  <!-- Edit mode -->
                  <ng-container *ngIf="editingItemId === item.id">
                    <input
                      type="text"
                      class="p-inputtext item-edit-input"
                      [(ngModel)]="editingQuestion"
                      (keydown)="onEditItemKeydown($event, template, item)"
                      autofocus />
                    <div class="item-actions">
                      <p-button
                        icon="pi pi-check"
                        [text]="true"
                        severity="success"
                        size="small"
                        pTooltip="Save"
                        tooltipPosition="top"
                        [loading]="savingItemId === item.id"
                        (onClick)="saveEditItem(template, item)" />
                      <p-button
                        icon="pi pi-times"
                        [text]="true"
                        severity="secondary"
                        size="small"
                        pTooltip="Cancel"
                        tooltipPosition="top"
                        (onClick)="cancelEditItem()" />
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Empty state -->
              <div *ngIf="!template.items || template.items.length === 0" class="items-empty">
                <i class="pi pi-inbox"></i>
                <span>No items yet — add the first question below.</span>
              </div>

              <!-- Add new item row -->
              <div class="item-add-row">
                <i class="pi pi-plus item-add-icon"></i>
                <input
                  type="text"
                  class="p-inputtext item-add-input"
                  [ngModel]="getNewInlineInput(template.id)"
                  (ngModelChange)="setNewInlineInput(template.id, $event)"
                  placeholder="Add a new item and press Enter…"
                  (keydown)="onInlineAddKeydown($event, template)" />
                <p-button
                  label="Add"
                  icon="pi pi-check"
                  size="small"
                  severity="primary"
                  [outlined]="true"
                  [disabled]="!getNewInlineInput(template.id).trim()"
                  [loading]="addingItemForTemplate === template.id"
                  (onClick)="addItemInline(template)" />
              </div>

            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="5" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-list-check"></i></div>
              <p class="empty-message">No checklists found</p>
              <p class="empty-description">Add a checklist using the button above</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- Add Checklist Dialog (compound: name + initial items) -->
<p-dialog
  [visible]="displayDialog"
  (visibleChange)="displayDialog = $event"
  [header]="dialogMode === 'add' ? 'Add Checklist' : 'Edit Checklist'"
  [modal]="true"
  styleClass="dialog-checklist"
  [dismissableMask]="false"
  [closable]="true">

  <div class="form-dialog-form">
    <div class="form-dialog-container">

      <div class="form-row">
        <div class="field" [class.field-invalid]="nameTouched && !templateName.trim()">
          <label for="clName">Checklist Name <span class="required-star">*</span></label>
          <input
            id="clName"
            type="text"
            class="p-inputtext w-full"
            [(ngModel)]="templateName"
            placeholder="e.g. BISTEC Project Governance Check List"
            (blur)="nameTouched = true" />
          <small class="field-error" *ngIf="nameTouched && !templateName.trim()">
            Name is required
          </small>
        </div>
      </div>

      <!-- Status (edit only) -->
      <div class="form-row" *ngIf="dialogMode === 'edit'">
        <div class="field">
          <label>Status</label>
          <div class="status-toggle-row">
            <p-button
              [label]="templateIsActive ? 'Active' : 'Inactive'"
              [icon]="templateIsActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
              [severity]="templateIsActive ? 'success' : 'secondary'"
              [outlined]="!templateIsActive"
              (onClick)="templateIsActive = !templateIsActive"
              size="small" />
            <span class="status-toggle-hint text-muted text-sm">
              {{ templateIsActive ? 'Visible to Project Managers' : 'Hidden from Project Managers' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Items section (both add and edit) -->
      <ng-container>
        <div class="cl-items-section">
          <div class="cl-items-header">
            <span class="cl-items-title">
              <i class="pi pi-list"></i>
              Checklist Items
              <span class="cl-items-count">{{ formItems.length }}</span>
            </span>
          </div>

          <div class="cl-items-list" *ngIf="formItems.length > 0">
            <div *ngFor="let item of formItems; let i = index"
              class="cl-item-row"
              [class.cl-item-row--inactive]="item.isActive === false">
              <span class="cl-item-num"
                [style.background]="item.isActive === false ? 'var(--surface-400, #a1a1aa)' : ''">
                {{ i + 1 }}
              </span>
              <input
                type="text"
                class="p-inputtext cl-item-input"
                [(ngModel)]="item.question"
                placeholder="Enter question…" />
              <p-button
                [icon]="item.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [text]="true"
                [severity]="item.isActive ? 'success' : 'secondary'"
                size="small"
                [pTooltip]="item.isActive ? 'Active — click to deactivate' : 'Inactive — click to activate'"
                tooltipPosition="top"
                (onClick)="item.isActive = !item.isActive" />
              <p-button
                icon="pi pi-trash"
                [text]="true"
                severity="danger"
                size="small"
                pTooltip="Remove"
                tooltipPosition="top"
                (onClick)="removeItemFromForm(i)" />
            </div>
          </div>

          <div *ngIf="formItems.length === 0" class="cl-items-empty">
            <i class="pi pi-inbox"></i>
            <span>No items yet. Type a question below and press Enter.</span>
          </div>

          <div class="cl-add-item-row">
            <input
              type="text"
              class="p-inputtext cl-new-item-input"
              [(ngModel)]="newItemQuestion"
              placeholder="Type a checklist item and press Enter…"
              (keydown)="onNewItemKeydown($event)" />
            <p-button
              icon="pi pi-plus"
              label="Add"
              size="small"
              severity="primary"
              [outlined]="true"
              [disabled]="!newItemQuestion.trim()"
              (onClick)="addItemToForm()" />
          </div>
        </div>
      </ng-container>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()" severity="secondary" [outlined]="true" />
      <p-button
        [label]="dialogMode === 'add' ? 'Create Checklist' : 'Save Changes'"
        icon="pi pi-check"
        (onClick)="save()"
        severity="primary"
        [loading]="saving" />
    </div>
  </ng-template>
</p-dialog>
